/**
 * CreateChapter Page
 * Wrapper that renders ChapterEditor in create mode
 */
import { useParams } from "react-router-dom";
import { ChapterEditor } from "./ChapterEditor";

export default function CreateChapter() {
  const { id: novelId } = useParams<{ id: string }>();

  if (!novelId) {
    return (
      <div className="text-center py-12">
        <p className="text-slate-600">Novel not found.</p>
      </div>
    );
  }

  return <ChapterEditor mode="create" novelId={novelId} />;
}
